import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpRightIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 14.2 14.2",
	style: { enableBackground: "new 0 0 14.2 14.2" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.arrow-up-right-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "arrow-up-right-st0",
		d: "M1,13.2L13.2,1"
	}), /* @__PURE__ */ _jsx("path", {
		className: "arrow-up-right-st0",
		d: "M13.2,9.7V1H4.5"
	})] }) }) })]
});
export default SvgArrowUpRightIcon;
